<template>
  <div class="team-section">
    <div class="section-title">{{ roleType === 1 ? '团队' : '成员' }}完成情况</div>
    <CustomTable
      :tableData="teamData"
      :column="teamColumns"
      border
      class="team-table"
      :header-cell-style="headerCellStyle"
      max-height="350"
    >
      <template slot="teamCell" slot-scope="{ row }">
        <el-tag
          type="info"
          effect="plain"
          size="small"
          @click="teamClickHandle(row)"
        >{{ row.teamName }}</el-tag>
      </template>
      <template slot="monthCell" slot-scope="{ row }">
        <div
          v-for="(item, index) in (row.monthInfo || {}).starList || []"
          :key="index"
          class="finish-cell"
        >
          <span class="cell-text">{{ item.saleStar + '星医生' + (item.finishTargetNumber || 0) + '/' + (item.targetNumber || 0) }}</span>
          <span v-if="item.completeStatus === 1" class="status-undo"><i class="el-icon-success"></i>未完成</span>
          <span v-else-if="item.completeStatus === 2" class="status-done"><i class="el-icon-success"></i>完成</span>
          <span v-else-if="item.completeStatus === 3" class="status-excess">超额完成！</span>
        </div>
        <span v-if="!row.monthInfo" class="status-unset">-</span>
      </template>
      <template slot="quarterCell" slot-scope="{ row }">
        <div
          v-for="(item, index) in (row.quarterInfo || {}).starList || []"
          :key="index"
          class="finish-cell"
        >
          <span class="cell-text">{{ item.saleStar + '星医生' + (item.finishTargetNumber || 0) + '/' + (item.targetNumber || 0) }}</span>
          <span v-if="item.completeStatus === 1" class="status-undo"><i class="el-icon-success"></i>未完成</span>
          <span v-else-if="item.completeStatus === 2" class="status-done"><i class="el-icon-success"></i>完成</span>
          <span v-else-if="item.completeStatus === 3" class="status-excess">超额完成！</span>
        </div>
        <span v-if="!row.quarterInfo" class="status-unset">-</span>
      </template>
      <template slot="yearCell" slot-scope="{ row }">
        <div
          v-for="(item, index) in (row.yearInfo || {}).starList || []"
          :key="index"
          class="finish-cell"
        >
          <span class="cell-text">{{ item.saleStar + '星医生' + (item.finishTargetNumber || 0) + '/' + (item.targetNumber || 0) }}</span>
          <span v-if="item.completeStatus === 1" class="status-undo"><i class="el-icon-success"></i>未完成</span>
          <span v-else-if="item.completeStatus === 2" class="status-done"><i class="el-icon-success"></i>完成</span>
          <span v-else-if="item.completeStatus === 3" class="status-excess">超额完成！</span>
        </div>
        <span v-if="!row.yearInfo" class="status-unset">-</span>
      </template>
    </CustomTable>
  </div>
</template>

<script>
export default {
  name: 'TeamGoalFinishInfo',
  props: {
    roleType: {
      type: [String, Number],
      default: ''
    },
    
    teamData: {
      type: Array,
      default: () => []
    },
    teamColumns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    headerCellStyle() {
      return { background: '#F7F8F9', color: '#667182', fontWeight: 500 }
    },
    teamClickHandle(row) {
      if (row.rowType === 3) return
      this.$emit('teamClick', row)
    }
  },
  components: {
    CustomTable: () => import('@/components/CustomTable.vue')
  }
}
</script>

<style scoped lang="less">
.team-section {
  background: #fff;
  border-radius: 4px;
  padding: 20px 24px;

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1F2329;
    margin-bottom: 16px;
  }

  .team-table {
    /deep/ .el-table {
      font-size: 13px;
      color: #1F2329;
      border-color: #EBEAEE;

      &::before,
      &::after {
        background-color: #EBEAEE;
      }

      th {
        padding: 0 !important;
        height: 40px;
      }

      td {
        padding: 0 !important;
        height: 44px;
      }

      .cell {
        line-height: 20px;
      }

      .header-cell-medium-section {
        padding: 0 !important;
        line-height: 20px !important;
      }

      .cell-medium-section {
        padding: 0 !important;
      }
    }

    /deep/.el-tag--plain.el-tag--info {
      background-color: #F7F8F9;
      border-color: #EBEAEE;
      color: #667182;
      height: 24px;
      line-height: 22px;
      padding: 0 10px;
      border-radius: 12px;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        border-color: #1890FF;
        color: #1890FF;
      }
    }

    .finish-cell {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;

      .cell-text {
        width: 100px;
        font-size: 14px;
        color: #667182;
      }

      .status-done {
        color: #1890FF;

        i {
          margin-right: 2px;
        }
      }

      .status-excess {
        color: #F54A45;
      }

      .status-undo {
        color: #9AA0A8;

        i {
          margin-right: 2px;
        }
      }
    }
    .status-unset {
      color: #9AA0A8;
    }
  }
}
</style>
